import _Object$keys from "/app/node_modules/babel-runtime/core-js/object/keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Dropzone from "dropzone"; //eslint-disable-line
import awsEndpoint from "./urlsigner";

Dropzone.autoDiscover = false;

export default {
  props: {
    id: {
      type: String,
      required: true,
      default: "dropzone"
    },
    options: {
      type: Object,
      required: true
    },
    includeStyling: {
      type: Boolean,
      default: true,
      required: false
    },
    awss3: {
      type: Object,
      required: false,
      default: null
    },
    destroyDropzone: {
      type: Boolean,
      default: true,
      required: false
    },
    duplicateCheck: {
      type: Boolean,
      default: false,
      required: false
    },
    useCustomSlot: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function data() {
    return {
      isS3: false,
      isS3OverridesServerPropagation: false,
      wasQueueAutoProcess: true
    };
  },

  computed: {
    dropzoneSettings: function dropzoneSettings() {
      var defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      };
      _Object$keys(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key];
      }, this);
      if (this.awss3 !== null) {
        defaultValues["autoProcessQueue"] = false;
        this.isS3 = true; //eslint-disable-line
        this.isS3OverridesServerPropagation = this.awss3.sendFileToServer === false; //eslint-disable-line
        if (this.options.autoProcessQueue !== undefined) this.wasQueueAutoProcess = this.options.autoProcessQueue; //eslint-disable-line

        if (this.isS3OverridesServerPropagation) {
          defaultValues["url"] = function (files) {
            return files[0].s3Url;
          };
        }
      }
      return defaultValues;
    }
  },
  mounted: function mounted() {
    if (this.$isServer && this.hasBeenMounted) {
      return;
    }
    this.hasBeenMounted = true;

    this.dropzone = new Dropzone(this.$refs.dropzoneElement, this.dropzoneSettings);
    var vm = this;

    this.dropzone.on("thumbnail", function (file, dataUrl) {
      vm.$emit("vdropzone-thumbnail", file, dataUrl);
    });

    this.dropzone.on("addedfile", function (file) {
      var isDuplicate = false;
      if (vm.duplicateCheck) {
        if (this.files.length) {
          var _i, _len;
          for (_i = 0, _len = this.files.length; _i < _len - 1; _i++ // -1 to exclude current file
          ) {
            if (this.files[_i].name === file.name && this.files[_i].size === file.size && this.files[_i].lastModifiedDate.toString() === file.lastModifiedDate.toString()) {
              this.removeFile(file);
              isDuplicate = true;
              vm.$emit("vdropzone-duplicate-file", file);
            }
          }
        }
      }

      vm.$emit("vdropzone-file-added", file);
      if (vm.isS3 && vm.wasQueueAutoProcess) {
        vm.getSignedAndUploadToS3(file);
      }
    });

    this.dropzone.on("addedfiles", function (files) {
      vm.$emit("vdropzone-files-added", files);
    });

    this.dropzone.on("removedfile", function (file) {
      vm.$emit("vdropzone-removed-file", file);
      if (file.manuallyAdded) vm.dropzone.options.maxFiles++;
    });

    this.dropzone.on("success", function (file, response) {
      vm.$emit("vdropzone-success", file, response);
      if (vm.isS3) {
        if (vm.isS3OverridesServerPropagation) {
          var xmlResponse = new window.DOMParser().parseFromString(response, "text/xml");
          var s3ObjectLocation = xmlResponse.firstChild.children[0].innerHTML;
          vm.$emit("vdropzone-s3-upload-success", s3ObjectLocation);
        }
        if (vm.wasQueueAutoProcess) vm.setOption("autoProcessQueue", false);
      }
    });

    this.dropzone.on("successmultiple", function (file, response) {
      vm.$emit("vdropzone-success-multiple", file, response);
    });

    this.dropzone.on("error", function (file, message, xhr) {
      vm.$emit("vdropzone-error", file, message, xhr);
      if (this.isS3) vm.$emit("vdropzone-s3-upload-error");
    });

    this.dropzone.on("errormultiple", function (files, message, xhr) {
      vm.$emit("vdropzone-error-multiple", files, message, xhr);
    });

    this.dropzone.on("sending", function (file, xhr, formData) {
      if (vm.isS3) {
        if (vm.isS3OverridesServerPropagation) {
          var signature = file.s3Signature;
          _Object$keys(signature).forEach(function (key) {
            formData.append(key, signature[key]);
          });
        } else {
          formData.append("s3ObjectLocation", file.s3ObjectLocation);
        }
      }
      vm.$emit("vdropzone-sending", file, xhr, formData);
    });

    this.dropzone.on("sendingmultiple", function (file, xhr, formData) {
      vm.$emit("vdropzone-sending-multiple", file, xhr, formData);
    });

    this.dropzone.on("complete", function (file) {
      vm.$emit("vdropzone-complete", file);
    });

    this.dropzone.on("completemultiple", function (files) {
      vm.$emit("vdropzone-complete-multiple", files);
    });

    this.dropzone.on("canceled", function (file) {
      vm.$emit("vdropzone-canceled", file);
    });

    this.dropzone.on("canceledmultiple", function (files) {
      vm.$emit("vdropzone-canceled-multiple", files);
    });

    this.dropzone.on("maxfilesreached", function (files) {
      vm.$emit("vdropzone-max-files-reached", files);
    });

    this.dropzone.on("maxfilesexceeded", function (file) {
      vm.$emit("vdropzone-max-files-exceeded", file);
    });

    this.dropzone.on("processing", function (file) {
      vm.$emit("vdropzone-processing", file);
    });

    this.dropzone.on("processing", function (file) {
      vm.$emit("vdropzone-processing", file);
    });

    this.dropzone.on("processingmultiple", function (files) {
      vm.$emit("vdropzone-processing-multiple", files);
    });

    this.dropzone.on("uploadprogress", function (file, progress, bytesSent) {
      vm.$emit("vdropzone-upload-progress", file, progress, bytesSent);
    });

    this.dropzone.on("totaluploadprogress", function (totaluploadprogress, totalBytes, totalBytesSent) {
      vm.$emit("vdropzone-total-upload-progress", totaluploadprogress, totalBytes, totalBytesSent);
    });

    this.dropzone.on("reset", function () {
      vm.$emit("vdropzone-reset");
    });

    this.dropzone.on("queuecomplete", function () {
      vm.$emit("vdropzone-queue-complete");
    });

    this.dropzone.on("drop", function (event) {
      vm.$emit("vdropzone-drop", event);
    });

    this.dropzone.on("dragstart", function (event) {
      vm.$emit("vdropzone-drag-start", event);
    });

    this.dropzone.on("dragend", function (event) {
      vm.$emit("vdropzone-drag-end", event);
    });

    this.dropzone.on("dragenter", function (event) {
      vm.$emit("vdropzone-drag-enter", event);
    });

    this.dropzone.on("dragover", function (event) {
      vm.$emit("vdropzone-drag-over", event);
    });

    this.dropzone.on("dragleave", function (event) {
      vm.$emit("vdropzone-drag-leave", event);
    });

    vm.$emit("vdropzone-mounted");
  },
  beforeDestroy: function beforeDestroy() {
    if (this.destroyDropzone) this.dropzone.destroy();
  },

  methods: {
    manuallyAddFile: function manuallyAddFile(file, fileUrl) {
      file.manuallyAdded = true;
      this.dropzone.emit("addedfile", file);
      var containsImageFileType = false;
      if (fileUrl.indexOf(".png") > -1 || fileUrl.indexOf(".jpg") > -1 || fileUrl.indexOf(".jpeg") > -1) containsImageFileType = true;
      if (this.dropzone.options.createImageThumbnails && containsImageFileType && file.size <= this.dropzone.options.maxThumbnailFilesize * 1024 * 1024) {
        fileUrl && this.dropzone.emit("thumbnail", file, fileUrl);

        var thumbnails = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
        for (var i = 0; i < thumbnails.length; i++) {
          thumbnails[i].style.width = this.dropzoneSettings.thumbnailWidth + "px";
          thumbnails[i].style.height = this.dropzoneSettings.thumbnailHeight + "px";
          thumbnails[i].style["object-fit"] = "contain";
        }
      }
      this.dropzone.emit("complete", file);
      if (this.dropzone.options.maxFiles) this.dropzone.options.maxFiles--;
      this.dropzone.files.push(file);
      this.$emit("vdropzone-file-added-manually", file);
    },
    setOption: function setOption(option, value) {
      this.dropzone.options[option] = value;
    },
    removeAllFiles: function removeAllFiles(bool) {
      this.dropzone.removeAllFiles(bool);
    },
    processQueue: function processQueue() {
      var _this = this;

      var dropzoneEle = this.dropzone;
      if (this.isS3 && !this.wasQueueAutoProcess) {
        this.getQueuedFiles().forEach(function (file) {
          _this.getSignedAndUploadToS3(file);
        });
      } else {
        this.dropzone.processQueue();
      }
      this.dropzone.on("success", function () {
        dropzoneEle.options.autoProcessQueue = true;
      });
      this.dropzone.on("queuecomplete", function () {
        dropzoneEle.options.autoProcessQueue = false;
      });
    },
    init: function init() {
      return this.dropzone.init();
    },
    destroy: function destroy() {
      return this.dropzone.destroy();
    },
    updateTotalUploadProgress: function updateTotalUploadProgress() {
      return this.dropzone.updateTotalUploadProgress();
    },
    getFallbackForm: function getFallbackForm() {
      return this.dropzone.getFallbackForm();
    },
    getExistingFallback: function getExistingFallback() {
      return this.dropzone.getExistingFallback();
    },
    setupEventListeners: function setupEventListeners() {
      return this.dropzone.setupEventListeners();
    },
    removeEventListeners: function removeEventListeners() {
      return this.dropzone.removeEventListeners();
    },
    disable: function disable() {
      return this.dropzone.disable();
    },
    enable: function enable() {
      return this.dropzone.enable();
    },
    filesize: function filesize(size) {
      return this.dropzone.filesize(size);
    },
    accept: function accept(file, done) {
      return this.dropzone.accept(file, done);
    },
    addFile: function addFile(file) {
      return this.dropzone.addFile(file);
    },
    removeFile: function removeFile(file) {
      this.dropzone.removeFile(file);
    },
    getAcceptedFiles: function getAcceptedFiles() {
      return this.dropzone.getAcceptedFiles();
    },
    getRejectedFiles: function getRejectedFiles() {
      return this.dropzone.getRejectedFiles();
    },
    getFilesWithStatus: function getFilesWithStatus() {
      return this.dropzone.getFilesWithStatus();
    },
    getQueuedFiles: function getQueuedFiles() {
      return this.dropzone.getQueuedFiles();
    },
    getUploadingFiles: function getUploadingFiles() {
      return this.dropzone.getUploadingFiles();
    },
    getAddedFiles: function getAddedFiles() {
      return this.dropzone.getAddedFiles();
    },
    getActiveFiles: function getActiveFiles() {
      return this.dropzone.getActiveFiles();
    },
    getSignedAndUploadToS3: function getSignedAndUploadToS3(file) {
      var _this2 = this;

      var promise = awsEndpoint.sendFile(file, this.awss3, this.isS3OverridesServerPropagation);
      console.log("PROMESA", promise);
      if (!this.isS3OverridesServerPropagation) {
        promise.then(function (response) {
          if (response.success) {
            file.s3ObjectLocation = response.message;
            setTimeout(function () {
              return _this2.dropzone.processFile(file);
            });
            _this2.$emit("vdropzone-s3-upload-success", response.message);
          } else {
            if ("undefined" !== typeof response.message) {
              _this2.$emit("vdropzone-s3-upload-error", response.message);
            } else {
              console.log("s3uploaderror", response);
              _this2.$emit('vdropzone-s3-upload-unauthorized');
              // this.$emit(
              //   "vdropzone-s3-upload-error",
              //   "Network Error : Could not send request to AWS. (Maybe CORS error)------>"
              // );
            }
          }
        }).catch(function (error) {
          console.log("Error msg dropzone-->", error);
        });
      } else {
        promise.then(function () {
          setTimeout(function () {
            return _this2.dropzone.processFile(file);
          });
        });
      }
      promise.catch(function (error) {
        alert(error);
      });
    },
    setAWSSigningURL: function setAWSSigningURL(location) {
      if (this.isS3) {
        this.awss3.signingURL = location;
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/dropzone/dropzone.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/dropzone/dropzone.vue
// module chunks = 0 1 2 3